import React from "react";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import styles from "./Accodion.module.scss";
import MarkEditOrFilled from "./Components/MarkEditOrFilled";
const EditableAccordionContents = ({ FormElement, title, titleId }) => {
  return (
    <React.Fragment>
      <Accordion classes={{ root: styles.rootAccordion }} square={true}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Stack alignItems="center" direction="row" spacing={1}>
            <MarkEditOrFilled titleId={titleId} />
            <Typography>{title.replace(/ي/g, "ی")}</Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails className={styles.accordionDetails}>
          {FormElement}
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};

export default EditableAccordionContents;
